import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IButtonList } from './iButton-list';

enum TOOLTIP_POSITION {
  AFTER = 'after',
  BEFORE = 'before',
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right'
}
@Component({
  selector: 'siu-button-list',
  templateUrl: './button-list.component.html',
  styleUrls: ['./button-list.component.scss']
})
export class ButtonListComponent implements OnInit {

  tooltipPositionEnum = TOOLTIP_POSITION;
  @Input() label: string;
  @Input() buttonType: string = "button";
  @Input() color: string;
  @Input() tooltip: string;
  @Input() tooltipPosition: string = this.tooltipPositionEnum.ABOVE;
  @Input() disabled: boolean = false;
  @Input() itemsList: IButtonList[]=[];
  @Output('on-click') onClickEvent: EventEmitter<any> = new EventEmitter();
  principalIcon: string;
  principalLabel: string;
  principalAction: string;

  constructor() {
  }

  ngOnInit() {
    this.handlePrincipalItem();
  }

  handleClick() {
    if (this.disabled) return false;
    this.onClickEvent.emit(this.principalAction);
  }
  handleClickItemSelect(Valueicon: string, Valuelabel : string, Valueaction: string) {
        this.principalIcon=Valueicon;
        this.principalLabel=Valuelabel;
        this.principalAction=Valueaction;
        this.handleClick();
  }

  handlePrincipalItem() {
    for (let item of this.itemsList) {
      if (item.principal){
        this.principalIcon=item.icon;
        this.principalLabel=item.label;
        this.principalAction=item.action;
      }
  }

  }
}
